/*

*/
export default {
  data() {
    return {
      orderStausMsgs: {
        100: {
          name: this.$t('order.statusName.100')
        },
        200: {
          name: this.$t('order.statusName.200'),
          status: this.$t('order.status.200'),
          value: this.$t('order.statusMsg1.200'),
        },
        300: {
          name: this.$t('order.statusName.300'),
          status: this.$t('order.status.300'),
          value: this.$t('order.statusMsg1.300'),
        },
        400: {
          name: this.$t('order.statusName.400'),
          status: this.$t('order.status.400'),
          value: this.$t('order.statusMsg1.400'),
        },
        500: {
          name: this.$t('order.statusName.500'),
          status: this.$t('order.status.500'),
          value: this.$t('order.statusMsg1.500'),
        },
        600: {
          name: this.$t('order.statusName.600'),
          status: this.$t('order.status.600'),
          value: this.$t('order.statusMsg1.600'),
        },
        610: {
          name: this.$t('order.statusName.610'),
          status: this.$t('order.status.610'),
          value: this.$t('order.statusMsg1.610'),
        },
        1000: {
          status: this.$t('order.status.1000'),
          Driver: this.$t('order.statusMsg2.1000'),
          value: this.$t('order.statusMsg1.1000'),
        },
        1010: {
          status: this.$t('order.status.1010'),
          Driver: this.$t('order.statusMsg2.1010'),
          value: this.$t('order.statusMsg1.1010'),
        },
        1020: {
          status: this.$t('order.status.1020'),
          Driver: this.$t('order.statusMsg2.1020'),
          value: this.$t('order.statusMsg1.1020'),
        },
        1030: {
          status: this.$t('order.status.1030'),
          Driver: this.$t('order.statusMsg2.1030'),
          value: this.$t('order.statusMsg1.1030'),
        },
        620: {
          name: this.$t('order.statusName.620'),
          status: this.$t('order.status.620'),
          value: this.$t('order.statusMsg1.620'),
        },
        630: {
          name: this.$t('order.statusName.630'),
          status: this.$t('order.status.630'),
          value: this.$t('order.statusMsg1.630'),
        },
        700: {
          name: this.$t('order.statusName.700'),
          status: this.$t('order.status.700'),
          value: this.$t('order.statusMsg1.700'),
          CourierInfo: this.$t('order.statusMsg3.700'),
        },
        800: {
          name: this.$t('order.statusName.800'),
          status: this.$t('order.status.800'),
          value: this.$t('order.statusMsg1.800'),
          CourierInfo: this.$t('order.statusMsg3.800'),
        },
        900: {
          name: this.$t('order.statusName.900'),
          status: this.$t('order.status.900'),
          value: this.$t('order.statusMsg1.900'),
          CourierInfo: this.$t('order.statusMsg3.900'),
        },
        1040: {
          status: this.$t('order.status.1040'),
          Driver: this.$t('order.statusMsg2.1040'),
          Seller: this.$t('order.statusMsg4.1040'),
          value: this.$t('order.statusMsg1.1040'),
        },
        1080: {
          name: this.$t('order.statusName.1080'),
          status: this.$t('order.status.1080'),
          value: this.$t('order.statusMsg1.1080'),
          CourierInfo: this.$t('order.statusMsg3.1080'),
        },
      }
    }
  },
  computed: {
    orderStatusCode() {
      if (this.shipmentStatusCode - 0 >= 200 && this.shipmentStatusCode - 0 < 300) {
        return 200;
      }
      //  * 付款成功
      // PAID(300),
      if (this.shipmentStatusCode - 0 >= 300 && this.shipmentStatusCode - 0 < 400) {
        return 300;
      }
      //  * 商家已接单
      // ACCEPTED(400),
      if (this.shipmentStatusCode - 0 >= 400 && this.shipmentStatusCode - 0 < 500) {
        return 400;
      }
      //  * 商家备餐中
      // PREPARING(500),
      if (this.shipmentStatusCode - 0 >= 500 && this.shipmentStatusCode - 0 < 600) {
        return 500;
      }
      //* 等待骑手到店取货
      // READY(600)
      if (this.shipmentStatusCode - 0 >= 600 && this.shipmentStatusCode - 0 < 610) {
        return 600;
      }
      // Searching for Courier 寻找棋手
      if (this.shipmentStatusCode - 0 >= 610 && this.shipmentStatusCode - 0 < 620) {
        return 610;
      }
      //   Driver Assigned  找到棋手
      if (this.shipmentStatusCode - 0 >= 620 && this.shipmentStatusCode - 0 < 630) {
        return 620;
      }
      /// / On the Way Pick Up  棋手正在来的路上
      if (this.shipmentStatusCode - 0 >= 630 && this.shipmentStatusCode - 0 < 700) {
        return 630;
      }
      //  * 骑手到店已取货
      // PICKED_UP(700),
      if (this.shipmentStatusCode - 0 >= 700 && this.shipmentStatusCode - 0 < 800) {
        return 700;
      }
      //  * 配送中
      // DELIVERING(800)  //Delivering to customer  棋手正在 送货
      if (this.shipmentStatusCode - 0 >= 800 && this.shipmentStatusCode - 0 < 900) {
        return 800;
      }
      //  * 已送达
      // DELIVERED(900),       // Delivered   交付完成
      if (this.shipmentStatusCode - 0 >= 900 && this.shipmentStatusCode - 0 < 1000) {
        return 900;
      }
      if (this.shipmentStatusCode - 0 >= 1000 && this.shipmentStatusCode - 0 <= 1030) {
        return 610;
      }
      /// // 订单失败状态
      if (this.shipmentStatusCode - 0 > 1030 && this.shipmentStatusCode - 0 <= 1040) {
        return 1040;
      }
      if (this.shipmentStatusCode - 0 >= 1080 && this.shipmentStatusCode - 0 < 1090) {
        return 1080;
      }
      return '';
    },
    orderMsgs() {
      return this.orderStausMsgs[this.orderStatusCode]
    },
    // 骑手送货中
    isRiderToBuyer() {
      return [700, 800].includes(this.shipmentStatusCode)
    },
    isFinishedDELIVERY() {
      return this.serviceTypeStatus === 'DELIVERY' &&
        [
          200,
          300,
          400,
          500,
          600,
          610,
          620,
          630,
          700,
          800,
          900,
          1040,
          1080
        ].includes(this.shipmentStatusCode)
    },
    isCanceledDELIVERY() {
      return this.serviceTypeStatus === 'DELIVERY' &&
        [1040, 1050].includes(this.shipmentStatusCode)
    },
    resultSubPath() {
      const paths = {
        // DELIVERY
        '100_DELIVERY': 'success',
        '200_DELIVERY': 'success',
        '300_DELIVERY': 'success',
        '400_DELIVERY': 'success',
        '500_DELIVERY': 'success',
        '600_DELIVERY': 'success',
        '610_DELIVERY': 'success',
        '620_DELIVERY': 'success',
        '630_DELIVERY': 'success',
        '700_DELIVERY': 'success',
        '800_DELIVERY': 'success',
        '900_DELIVERY': 'finished',
        '1000_DELIVERY': 'success',
        '1010_DELIVERY': 'success',
        '1020_DELIVERY': 'success',
        '1030_DELIVERY': 'success',
        '1040_DELIVERY': 'canceled',
        '1050_DELIVERY': 'canceled',
        '1080_DELIVERY': 'completed',
        // PICK_UP
        '200_PICK_UP': 'waiting',
        '300_PICK_UP': 'success',
        '400_PICK_UP': 'accepted',
        '500_PICK_UP': 'accepted',
        '600_PICK_UP': 'finished',
        '700_PICK_UP': '',
        '800_PICK_UP': '',
        '900_PICK_UP': '',
        '1000_PICK_UP': '',
        '1010_PICK_UP': '',
        '1020_PICK_UP': '',
        '1030_PICK_UP': '',
        '1040_PICK_UP': 'canceled',
        '1050_PICK_UP': 'canceled',
        '1080_PICK_UP': 'completed',
        // DINE_IN
        '200_DINE_IN': 'waiting',
        '300_DINE_IN': 'success',
        '400_DINE_IN': 'accepted',
        '500_DINE_IN': 'accepted',
        '600_DINE_IN': 'finished',
        '700_DINE_IN': '',
        '800_DINE_IN': '',
        '900_DINE_IN': '',
        '1000_DINE_IN': '',
        '1010_DINE_IN': '',
        '1020_DINE_IN': '',
        '1030_DINE_IN': '',
        '1040_DINE_IN': 'canceled',
        '1050_DINE_IN': 'canceled',
        '1080_DINE_IN': 'completed',
        '1040_FULL_DINE_IN': 'canceled',
        '1080_FULL_DINE_IN': 'completed'
      }
      return paths[`${this.shipmentStatusCode}_${this.serviceTypeStatus}`];
    },
    isSuccessDELIVERY() {
      return this.serviceTypeStatus === 'DELIVERY' &&
        [
          200,
          300,
          400,
          500,
          600,
          610,
          620,
          630,
          700,
          800,
          900,
          1000,
          1010,
          1020,
          1030,
          1040,
          1050,
          1080
        ].includes(this.shipmentStatusCode)
    },
    isOVO() {
      return ['XE_OVO', 'OVO', 'MIDE_OVO'].includes(this.paymentMethodTypeId)
    },
    isGoPay() {
      return ['MIDE_GOPAY'].includes(this.paymentMethodTypeId)
    },
    isShopeePay() {
      return ['XE_SHOPEEPAY', 'MIDE_SHOPEEPAY'].includes(this.paymentMethodTypeId)
    },
    isDana() {
      // return this.paymentName === 'DANA';
      return ['XE_DANA'].includes(this.paymentMethodTypeId)
    }
  },

  methods: {
    isRiderError(val) {
      return [1000, 1010, 1020, 1030, 1040].includes(val - 0);
    }
  }
}
